// #region IMPORTS
import { useAppUpdateWatcher } from './useAppUpdateWatcher';
// #endregion

// #region COMPONENT
/**
 * Headless sibling of `<ToastHandler />`: owns the auto-update lifecycle for the
 * whole app session. Mounted once in index.js and never unmounted, so the
 * pending reload can never be cancelled by a route change.
 *
 * @returns {null} Renders nothing
 */
const AppUpdateWatcher = () => {
  useAppUpdateWatcher();

  return null;
};
// #endregion

export { AppUpdateWatcher };
